import { Spacing } from '@genial/design-tokens';
import { Utils } from '@genial/utils';
import { Box } from 'native-base';
import React, { useMemo } from 'react';
import { FlatList } from 'react-native';

import { InfoResponsiveContainer } from '../InfoResponsiveContainer';

import { CustomerDuckInfoProps, CustomerDuckInfo } from './components/CustomerDuckInfo';

interface InfoContainerProps {
  title: string;
  values: CustomerDuckInfoProps[];
  columns?: number;
  forceEqualColumns?: boolean;
}

export const InfoContainer: React.FC<InfoContainerProps> = ({
  title,
  values,
  columns = values.length,
  forceEqualColumns = false,
}) => {
  const correctColumns = Math.min(columns, values.length);
  const rows = Math.ceil(values.length / correctColumns);

  const singleRow = rows === 1;
  const equalColumns = !singleRow || forceEqualColumns;
  const singleColumn = correctColumns === 1;

  const columnPercentage = `${100 / correctColumns}%`;

  const SingleColumnSeparator = useMemo(
    () => (singleColumn ? () => <Box h="stack.nano" /> : null),
    [singleColumn]
  );

  return (
    <InfoResponsiveContainer title={title}>
      <FlatList
        key={`${correctColumns}-${values.length}-info-container-flatList`}
        columnWrapperStyle={
          !singleColumn && {
            justifyContent: !equalColumns ? 'space-between' : undefined,
            paddingVertical: Utils.Token.ToInt(Spacing, 'stack.nano'),
          }
        }
        keyExtractor={(field, index) => `${field.label || index}-${correctColumns}-info-container`}
        data={values}
        ItemSeparatorComponent={SingleColumnSeparator}
        renderItem={({ item: field }) => (
          <CustomerDuckInfo
            {...field}
            minW={columnPercentage}
            w={!equalColumns ? undefined : columnPercentage}
          />
        )}
        numColumns={correctColumns}
      />
    </InfoResponsiveContainer>
  );
};
